


































import Vue from 'vue';

export default Vue.extend({
  data() {
    return {
      loggerNames: [] as string[],
      selectedLogger: '',
      selectedLevel: 'INFO',
      currentLevel: '',
      error: '',
      levels: ['TRACE', 'DEBUG', 'INFO', 'WARN', 'ERROR', 'OFF']
    };
  },
  created() {
    this.fetchLoggers();
  },
  methods: {
    async fetchLoggers() {
      this.error = '';
      try {
        const response = await fetch('/api/actuator/loggers');
        if (!response.ok) throw new Error('Не удалось получить список логгеров');
        const data = await response.json();
        this.loggerNames = Object.keys(data.loggers || {});
      } catch (e) {
        this.error = e.message || 'Ошибка при загрузке логгеров';
      }
    },
    async loadLoggerInfo() {
      this.error = '';
      this.currentLevel = '';
      if (!this.selectedLogger) return;
      try {
        const response = await fetch(`/api/actuator/loggers/${this.selectedLogger}`);
        if (!response.ok) throw new Error('Logger not found');
        const data = await response.json();
        this.currentLevel = data.effectiveLevel || 'UNKNOWN';
        this.selectedLevel = data.effectiveLevel || 'INFO';
      } catch (e) {
        this.error = e.message || 'Ошибка при получении информации о логгере';
      }
    },
    async changeLoggerLevel() {
      this.error = '';
      if (!this.selectedLogger) {
        this.error = 'Сначала выберите логгер';
        return;
      }
      try {
        const response = await fetch(`/api/actuator/loggers/${this.selectedLogger}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ configuredLevel: this.selectedLevel })
        });
        if (!response.ok) throw new Error('Ошибка при смене уровня логгера');
        this.loadLoggerInfo();
      } catch (e) {
        this.error = e.message || 'Ошибка при изменении уровня логгера';
      }
    }
  }
});
